import { render, staticRenderFns } from "./DistributionGoods.vue?vue&type=template&id=2c95c335&"
import script from "./DistributionGoods.vue?vue&type=script&lang=js&"
export * from "./DistributionGoods.vue?vue&type=script&lang=js&"
import style0 from "./DistributionGoods.vue?vue&type=style&index=0&id=2c95c335&prod&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports